"use strict";
/*
 * Created on 04 30 2021
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var index_1 = require("../../../core/utils/index");

var SelloutImpactReportDetailRow4BOXDTO_1 = require("../model/SelloutImpactReportDetailRow4BOXDTO");

var SelloutImpactReportDetailRow4BOXDTOConverter_1 = require("./SelloutImpactReportDetailRow4BOXDTOConverter");

var SelloutImpactReportDetailValuesDTOConverter_1 = require("./SelloutImpactReportDetailValuesDTOConverter");
/**
 * @author Jaroslav Sevcik
 * @author Jan Prokop
 */


var SelloutImpactReportDetailRow4BOXDTOConverterImpl =
/*#__PURE__*/
function (_SelloutImpactReportD) {
  _inherits(SelloutImpactReportDetailRow4BOXDTOConverterImpl, _SelloutImpactReportD);

  function SelloutImpactReportDetailRow4BOXDTOConverterImpl(valuesConverter) {
    var _this;

    _classCallCheck(this, SelloutImpactReportDetailRow4BOXDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutImpactReportDetailRow4BOXDTOConverterImpl).call(this));
    _this.valuesConverter = valuesConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SelloutImpactReportDetailRow4BOXDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new SelloutImpactReportDetailRow4BOXDTO_1.SelloutImpactReportDetailRow4BOXDTO(conversions.asObjectList(source, 'hierarchy', function (v) {
        return index_1.Utils.asString(v);
      }), conversions.asObjectOpt(source, 'productName', function (v) {
        return index_1.Utils.asString(v);
      }), conversions.asObjectList(source, 'supplierNames', function (v) {
        return index_1.Utils.asString(v);
      }), conversions.asObject(source, 'values', function (v) {
        return _this2.valuesConverter.toObject(v, conversions);
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      return {
        hierarchy: conversions.asObjectArray(source, 'hierarchy', function (v) {
          return v;
        }),
        productName: source.productName,
        supplierNames: conversions.asObjectArray(source, 'supplierNames', function (v) {
          return v;
        }),
        values: this.valuesConverter.toDocument(source.values, conversions)
      };
    }
  }]);

  return SelloutImpactReportDetailRow4BOXDTOConverterImpl;
}(SelloutImpactReportDetailRow4BOXDTOConverter_1.SelloutImpactReportDetailRow4BOXDTOConverter);

SelloutImpactReportDetailRow4BOXDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [SelloutImpactReportDetailValuesDTOConverter_1.SelloutImpactReportDetailValuesDTOConverter])], SelloutImpactReportDetailRow4BOXDTOConverterImpl);
exports.SelloutImpactReportDetailRow4BOXDTOConverterImpl = SelloutImpactReportDetailRow4BOXDTOConverterImpl;